import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {createReceipt, type CreateReceiptRequest} from '../../http/receipts/createReceipt';

export function useCreateReceipt(
	options?: UseMutationOptions<void, AxiosError, CreateReceiptRequest>,
): UseMutationResult<void, AxiosError, CreateReceiptRequest> {
	return useMutation<void, AxiosError, CreateReceiptRequest>(
		(request) => createReceipt(request).then(() => undefined),
		options,
	);
}
